module.exports = __webpack_public_path__ + "img/frosted.1aea78f8.png";